import React from 'react';
import PropTypes from 'prop-types';
import {
  MenuList,
  MenuListItem,
  SVGIcon,
} from '@pearsontechnology/aero-components';
import { getIcon } from 'Workspace/helpers';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { KnowledgeTypes } from 'constants/knowledgeMap';

import messages from './messages';
import { Menu, MenuListItemText } from './styles';

const AddKnowledgeMapMenu = ({ openModalSelector }) => {
  const menuPluginList = [
    KnowledgeTypes.IMPORT,
  ];

  return (
    <Menu>
      <MenuList>
        {menuPluginList.map((menuItemType) => (
          <MenuListItem
            key={menuItemType}
            onClick={() => openModalSelector(menuItemType)}
          >
            <SVGIcon
              icon={getIcon(menuItemType)}
              viewBox="0 0 24 24"
            />
            <MenuListItemText>
              {intl.formatMessage(messages[menuItemType])}
            </MenuListItemText>
          </MenuListItem>
        ))}
      </MenuList>
    </Menu>
  );
};

AddKnowledgeMapMenu.propTypes = {
  openModalSelector: PropTypes.func.isRequired,
};

export default AddKnowledgeMapMenu;
